import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import PredictionMarketDetail from "@/pages/PredictionMarketDetail";

export const Route = createFileRoute("/_app/prediction-markets/$eventId")({
  component: () => (
    <PageGate pageKey="prediction-markets"><PredictionMarketDetail /></PageGate>
  ),
});
